module.exports = __webpack_public_path__ + "assets/img/9.6e4aef20.png";